export default __webpack_public_path__ + "static/new-record-e8b79ee29cff9395d26ab27f0b94bde6.png";